export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-rose-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-72 h-72 bg-rose-200/30 rounded-full blur-3xl"></div>
            <img
              src="https://static.readdy.ai/image/f83fdda0eecfb5cfc6917dd44bd1d231/ca3d68874b94368976ea7ab964ebe5a4.jpeg"
              alt="Meltem Tiryaki - Inhaberin"
              className="relative rounded-2xl shadow-2xl w-full h-[500px] object-cover object-center"
            />
          </div>

          <div className="space-y-6">
            <div className="inline-block">
              <span className="text-rose-400 text-sm font-semibold tracking-wider uppercase">Über mich</span>
              <div className="h-0.5 w-16 bg-rose-400 mt-2"></div>
            </div>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Lernen Sie mich kennen
            </h2>

            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-8 shadow-lg max-w-2xl">
              <h3 className="text-3xl font-bold text-gray-900 mb-3">Meltem Tiryaki</h3>
              <p className="text-rose-400 font-semibold mb-6 text-lg">Inhaberin & Kosmetikerin</p>
              
              <p className="text-gray-600 text-lg leading-relaxed mb-4">
                Seit 2016 arbeite ich als staatlich anerkannte Kosmetikerin erfolgreich im Beauty-Bereich. Meine Leidenschaft für Schönheit und Wohlbefinden hat mich dazu inspiriert, mein eigenes Studio zu eröffnen, in dem ich Ihnen professionelle Behandlungen in einer entspannten und luxuriösen Atmosphäre biete.
              </p>
              
              <p className="text-gray-600 text-lg leading-relaxed">
                Ich möchte nicht nur meine Expertise in der klassischen Kosmetik anbieten, sondern habe mein Spektrum kontinuierlich erweitert – von Aqua Facial über dauerhafte Haarentfernung bis hin zu innovativen Behandlungen. Jede Behandlung wird individuell auf Ihre Bedürfnisse abgestimmt, damit Sie sich rundum verwöhnt und in Ihrer natürlichen Schönheit gestärkt fühlen.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-rose-400 mb-2">5+</div>
                <div className="text-sm text-gray-600">Jahre Erfahrung</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-rose-400 mb-2">200+</div>
                <div className="text-sm text-gray-600">Zufriedene Kunden</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-rose-400 mb-2">70+</div>
                <div className="text-sm text-gray-600">Behandlungen</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}